const leafNametreeNode = {
  title: 'ver equipos'
};

export default leafNametreeNode;
